var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _c(
            "el-select",
            {
              staticClass: "filter-item",
              attrs: {
                placeholder: "请选择设备类别",
                filterable: "",
                clearable: ""
              },
              model: {
                value: _vm.searchData.deviceTypeCode,
                callback: function($$v) {
                  _vm.$set(_vm.searchData, "deviceTypeCode", $$v)
                },
                expression: "searchData.deviceTypeCode"
              }
            },
            _vm._l(_vm.droplist, function(item, index) {
              return _c("el-option", {
                key: index,
                attrs: { label: item.name, value: item.code }
              })
            }),
            1
          ),
          _vm._v(" "),
          _c("el-input", {
            staticClass: "filter-item",
            staticStyle: { width: "200px" },
            attrs: { type: "text", placeholder: "请输入版本号" },
            model: {
              value: _vm.searchData.version,
              callback: function($$v) {
                _vm.$set(_vm.searchData, "version", $$v)
              },
              expression: "searchData.version"
            }
          }),
          _vm._v(" "),
          _c("el-input", {
            staticClass: "filter-item",
            staticStyle: { width: "200px" },
            attrs: { type: "text", placeholder: "请输入模板名称" },
            model: {
              value: _vm.searchData.templateName,
              callback: function($$v) {
                _vm.$set(_vm.searchData, "templateName", $$v)
              },
              expression: "searchData.templateName"
            }
          }),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "primary", icon: "el-icon-search" },
              on: { click: _vm.searchFun }
            },
            [_vm._v("查询")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "warning", icon: "el-icon-refresh" },
              on: { click: _vm.resetFun }
            },
            [_vm._v("重置")]
          ),
          _vm._v(" "),
          _vm.checkPermission(["brand:add"])
            ? _c(
                "el-button",
                {
                  staticClass: "filter-item",
                  attrs: { type: "primary", icon: "el-icon-plus" },
                  on: { click: _vm.addFun }
                },
                [_vm._v("新增")]
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.newadd,
            width: "500px",
            "before-close": _vm.closeRefund,
            center: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.newadd = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "addForm",
              staticClass: "mark",
              attrs: {
                model: _vm.addData,
                rules: _vm.rules,
                "label-width": "160px"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "设备类别：", prop: "deviceTypeId" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { filterable: "" },
                      model: {
                        value: _vm.addData.deviceTypeId,
                        callback: function($$v) {
                          _vm.$set(_vm.addData, "deviceTypeId", $$v)
                        },
                        expression: "addData.deviceTypeId"
                      }
                    },
                    _vm._l(_vm.droplist, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.name, value: item.id }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "设备类型：", prop: "firmwareType" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择" },
                      on: { change: _vm.changeappTypeFun },
                      model: {
                        value: _vm.addData.firmwareType,
                        callback: function($$v) {
                          _vm.$set(_vm.addData, "firmwareType", $$v)
                        },
                        expression: "addData.firmwareType"
                      }
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "wifi模块", value: "0" }
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "主板模块", value: "1" }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "固件名称：", prop: "name" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.addData.name,
                      callback: function($$v) {
                        _vm.$set(_vm.addData, "name", $$v)
                      },
                      expression: "addData.name"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "固件版本号：", prop: "version" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.addData.version,
                      callback: function($$v) {
                        _vm.$set(_vm.addData, "version", $$v)
                      },
                      expression: "addData.version"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "固件存放地址：", prop: "filePath" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.addData.filePath,
                      callback: function($$v) {
                        _vm.$set(_vm.addData, "filePath", $$v)
                      },
                      expression: "addData.filePath"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "选择模板：", prop: "templateId" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { filterable: "" },
                      model: {
                        value: _vm.addData.templateId,
                        callback: function($$v) {
                          _vm.$set(_vm.addData, "templateId", $$v)
                        },
                        expression: "addData.templateId"
                      }
                    },
                    _vm._l(_vm.droplist2, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.name, value: item.id }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "备注：", prop: "remark" } },
                [
                  _c("el-input", {
                    attrs: { type: "textarea", rows: 5 },
                    model: {
                      value: _vm.addData.remark,
                      callback: function($$v) {
                        _vm.$set(_vm.addData, "remark", $$v)
                      },
                      expression: "addData.remark"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "是否启用", prop: "enabled" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择" },
                      on: { change: _vm.changeEnabledFun },
                      model: {
                        value: _vm.addData.enabled,
                        callback: function($$v) {
                          _vm.$set(_vm.addData, "enabled", $$v)
                        },
                        expression: "addData.enabled"
                      }
                    },
                    [
                      _c("el-option", { attrs: { label: "启用", value: "1" } }),
                      _vm._v(" "),
                      _c("el-option", { attrs: { label: "禁用", value: "0" } })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.title == "新增"
                ? _c(
                    "el-form-item",
                    { attrs: { label: " " } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.onSubmit }
                        },
                        [_vm._v("提交")]
                      ),
                      _vm._v(" "),
                      _c("el-button", { on: { click: _vm.onCencal } }, [
                        _vm._v("取消")
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.title == "修改"
                ? _c(
                    "el-form-item",
                    { attrs: { label: " " } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.onUpdate }
                        },
                        [_vm._v("提交")]
                      ),
                      _vm._v(" "),
                      _c("el-button", { on: { click: _vm.onCencal } }, [
                        _vm._v("取消")
                      ])
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dropdown",
        [
          _c("el-button", { attrs: { type: "primary", scoped: "" } }, [
            _vm._v("\n      显示/隐藏列\n      "),
            _c("i", { staticClass: "el-icon-arrow-down el-icon--right" })
          ]),
          _vm._v(" "),
          _c(
            "el-dropdown-menu",
            { attrs: { slot: "dropdown" }, slot: "dropdown" },
            _vm._l(_vm.tableColumns, function(column, index) {
              return _c(
                "el-dropdown-item",
                {
                  key: index,
                  nativeOn: {
                    click: function($event) {
                      return _vm.showHide(column.isShow)
                    }
                  }
                },
                [
                  _c(
                    "el-checkbox",
                    {
                      model: {
                        value: column.isShow,
                        callback: function($$v) {
                          _vm.$set(column, "isShow", $$v)
                        },
                        expression: "column.isShow"
                      }
                    },
                    [_vm._v(_vm._s(column.label))]
                  )
                ],
                1
              )
            }),
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          attrs: {
            data: _vm.tableData,
            border: "",
            stripe: "",
            "cell-style": _vm.isCenter,
            "header-cell-style": _vm.isCenter,
            "highlight-current-row": ""
          }
        },
        [
          _c("el-table-column", {
            attrs: { type: "index", label: "序号", width: "50" }
          }),
          _vm._v(" "),
          _vm._l(_vm.tableColumns, function(column, index) {
            return [
              column.isShow
                ? _c("el-table-column", {
                    key: index,
                    attrs: {
                      prop: column.prop,
                      label: column.label,
                      formatter: column.formatter,
                      width: column.width,
                      sortable: column.sortable
                    }
                  })
                : _vm._e()
            ]
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "操作", width: "230", prop: "" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm.checkPermission(["brand:updata"])
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              title: "修改",
                              size: "mini"
                            },
                            on: {
                              click: function($event) {
                                return _vm.updateMenu(scope.row)
                              }
                            }
                          },
                          [_vm._v("修改")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.checkPermission(["brand:del"])
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "danger",
                              title: "删除",
                              size: "mini"
                            },
                            on: {
                              click: function($event) {
                                return _vm.delMenu(scope.row)
                              }
                            }
                          },
                          [_vm._v("删除")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "warning", title: "推荐", size: "mini" },
                        on: {
                          click: function($event) {
                            return _vm.RecommendFun(scope.row)
                          }
                        }
                      },
                      [_vm._v("推荐")]
                    )
                  ]
                }
              }
            ])
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pagination-container" },
        [
          _c("el-pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.pageData.total > 0,
                expression: "pageData.total>0"
              }
            ],
            attrs: {
              "current-page": _vm.pageData.page,
              "page-sizes": [10, 20, 30, 40, 50, 100, 200, 300, 400, 500],
              "page-size": _vm.pageData.rows,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.pageData.total
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }